/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import withForm from 'modules/common/hoc/withForm';
import SecuredImage from 'modules/common/components/SecuredImage';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';
import * as c from '../constant';

function MarriageImageContainer({
  info,
  page,
  getImage,
  formData,
  setFormData,
  updating,
  getMarriageCertificateList,
  updateNewImage,
}) {
  const onUpload = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      setFormData({
        ...formData,
        image: reader.result,
        file,
        imagePreviewUrl: reader.result,
        isImageUpdated: page === 'front_page' ? 'FRONT' : 'BACK',
      });
    };

    reader.readAsDataURL(file);
  };
  const setModal = useContext(ModalContext);
  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append(`${page}`, _.get(formData, 'file'));
    data.append('volume', _.get(formData, 'volume'));
    data.append('husband_first_name', _.get(formData, 'husband_first_name'));
    data.append('husband_last_name', _.get(formData, 'husband_last_name'));
    data.append('wife_first_name', _.get(formData, 'wife_first_name'));
    data.append('wife_last_name', _.get(formData, 'wife_last_name'));
    data.append('registry_number', _.get(formData, 'registry_number'));
    data.append('date_marriage', _.get(formData, 'date_marriage'));
    data.append('_method', 'put');
    data.append('isImageUpdated', _.get(formData, 'isImageUpdated'));
    if (page === 'front_page') {
      data.append('back_page', _.get(formData, 'back_page'));
    } else {
      data.append('front_page', _.get(formData, 'front_page'));
    }
    updateNewImage(_.get(info, 'id'), data, () => {
      getMarriageCertificateList();
      setModal({ isOpen: false });
    });
  };

  useEffect(() => {
    getImage({ file_name: _.get(info, `attributes.${page}`) }, (data) => {
      setFormData({
        ...formData,
        front_page: _.get(info, 'attributes.front_page'),
        back_page: _.get(info, 'attributes.back_page'),
        image: _.get(data, `data.presigned_url`),
        volume: _.get(info, 'attributes.volume'),
        id: _.get(info, 'id'),
        husband_first_name: _.get(info, 'attributes.husband_first_name'),
        husband_last_name: _.get(info, 'attributes.husband_last_name'),
        wife_first_name: _.get(info, 'attributes.wife_first_name'),
        wife_last_name: _.get(info, 'attributes.wife_last_name'),
        date_marriage: _.get(info, 'attributes.date_marriage'),
        registry_number: _.get(info, 'attributes.registry_number'),
        isImageUpdated: '0',
      });
    });
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit}>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-12 mb-2">
              <input
                required
                type="file"
                className="file-elip btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload}
              />
            </div>
            <div className="col-12 bc-image ">
              <SecuredImage
                ref={null}
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="Image not found"
                src={_.get(formData, 'image') || ImagePlaceholder}
              />
            </div>
          </div>
          <div className="row d-flex justify-content-center">
            <button
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-dark mr-5 "
            >
              <span className="font-weight-bold">Close</span>
            </button>
            <button
              disabled={updating}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary"
            >
              <span className="font-weight-bold">
                {updating ? <i className="fa fa-spin fa-spinner" /> : 'Update'}
              </span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

MarriageImageContainer.propTypes = {
  page: PropTypes.string.isRequired,
  getMarriageCertificateList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  info: PropTypes.instanceOf(Object).isRequired,
  getImage: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updateNewImage: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  fetching: api.loading.indexOf(c.GET_IMAGE) > -1,
  updating: api.loading.indexOf(c.UPLOAD_NEW_IMAGE) > -1,
  image: _.get(api, `${c.GET_IMAGE}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(MarriageImageContainer);
